export const hotelRulesDisclaimer = 'Please check detailed rules while reviewing your booking.';
